"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  assertQuickActionItems: () => assertQuickActionItems,
  assertQuickActionListener: () => assertQuickActionListener
});
module.exports = __toCommonJS(validate_exports);
function assertQuickActionItems(value) {
  if (!Array.isArray(value)) {
    throw new TypeError("QuickActions.setItems: items must be an array");
  }
  var seen = /* @__PURE__ */ new Set();
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      if (!item || typeof item !== "object" || typeof item.id !== "string" || !item.id.trim() || typeof item.title !== "string" || !item.title.trim() || item.subtitle !== void 0 && typeof item.subtitle !== "string" || seen.has(item.id)) {
        throw new TypeError("QuickActions.setItems: items require unique non-empty id and title with optional string subtitle");
      }
      seen.add(item.id);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function assertQuickActionListener(value) {
  if (typeof value !== "function") {
    throw new TypeError("QuickActions.addListener: listener must be a function");
  }
}
//# sourceMappingURL=validate.js.map
